"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SYSTEM_PROFILES = void 0;
/**
 * @deprecated `systemProfile` is no longer an access control in this app.
 *
 * It was never maintained as one: production ran 186 employees on 'Fleet User'
 * and exactly one on 'Admin' (the system account), so anything gated on it was
 * effectively closed to everyone. It also ran alongside the role/resource
 * matrix as a second, invisible permission model — the roles UI could not show
 * it, and the two disagreed. That cost real debugging time when a Super Admin
 * on 'Fleet User' was locked out of a page their role granted.
 *
 * Everything it used to gate is now a role action:
 *   - IoT device ID fields      → `asset.edit-device-ids`
 *   - Transfer report editing   → `asset-transfer.edit-record`
 *   - Onboarding report editing → `onboard-asset.edit-record`
 *   - Portal invite bypass      → removed; `employee.invite-portal` alone decides
 *   - API key management        → the `api_keys` resource grant alone decides
 *
 * The list survives only so stored values on existing Employee documents stay
 * valid and readable. Nothing reads it to make a decision. Do not gate anything
 * on it — use a role action.
 *
 * `ADMIN_PROFILES` was removed with its last consumer.
 */
exports.SYSTEM_PROFILES = [
    'Manager',
    'Manager - Reporting Access',
    'Manager - No Edit Access',
    'Employee',
    'IT Support',
    'Admin',
    'Dispatcher',
    'Manager & Admin',
    'Manager & Dispatcher',
    'Employee & Dispatcher',
    'Fleet User',
];
//# sourceMappingURL=system-profiles.js.map